import { ITags } from "./bucket-item.model";

export class PackageFolder {
  Id: string;
  LeafName: string;
  ItemType: string;
  Tags: Partial<ITags>[];
  CreatedBy: string;
  CreatedOn: string;
  ModifiedBy: string;
  ModifiedOn: string;
  Type: string;
  DirName: string;
  IsChecked: boolean;
}
